import { FormControl, FormHelperText } from "@mui/material";
import { FC, useId } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FullWidthTextFieldWrapper } from "@ryde/controls";
import { useDynamicFormsTranslate } from "@ryde/redux";
import { ICustomField, ILocationInfo } from "@ryde/shared";

import { LandingAddressWrapper } from "../landing-map";

interface ILandingAddressTemplate extends ICustomField {
  placeholder?: string | null;
}

export const LandingAddressTemplate: FC<ILandingAddressTemplate> = ({
  id,
  name,
  formLabel,
  placeholder,
  formAttributes,
  formValidation,
  e2eData = "address-template",
  uniqueAttrId,
}) => {
  const { control, setValue } = useFormContext();
  const generatedId = useId();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });

  const defaultValue = formAttributes?.isCoordinate ? { fullAddress: "" } : "";

  const onChange = (value: Partial<ILocationInfo>): void => {
    const newValue = formAttributes?.isCoordinate ? value : value.fullAddress;

    setValue(name as string, newValue, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  const inputId = uniqueAttrId ?? `${name}-${generatedId}`;

  return (
    <FullWidthTextFieldWrapper>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          return (
            <FormControl
              data-e2e={e2eData}
              data-e2e-field-name={name}
              data-e2e-id={`${name}_${id || ""}`}
              error={!!error}
            >
              <LandingAddressWrapper
                value={field.value || defaultValue}
                label={formLabelTranslated}
                placeholder={placeholder}
                onChange={onChange}
                error={!!error}
                formValidation={formValidation}
                inputId={inputId}
              />
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
          );
        }}
      />
    </FullWidthTextFieldWrapper>
  );
};
